/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QarOrgDetailResponseDto
 */
export interface QarOrgDetailResponseDto {
    /**
     * 
     * @type {string}
     * @memberof QarOrgDetailResponseDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof QarOrgDetailResponseDto
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof QarOrgDetailResponseDto
     */
    grant?: string;
    /**
     * AID for the related credential
     * @type {string}
     * @memberof QarOrgDetailResponseDto
     */
    aid?: string;
}

/**
 * Check if a given object implements the QarOrgDetailResponseDto interface.
 */
export function instanceOfQarOrgDetailResponseDto(value: object): boolean {
    return true;
}

export function QarOrgDetailResponseDtoFromJSON(json: any): QarOrgDetailResponseDto {
    return QarOrgDetailResponseDtoFromJSONTyped(json, false);
}

export function QarOrgDetailResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QarOrgDetailResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'grant': json['grant'] == null ? undefined : json['grant'],
        'aid': json['aid'] == null ? undefined : json['aid'],
    };
}

export function QarOrgDetailResponseDtoToJSON(value?: QarOrgDetailResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'userName': value['userName'],
        'grant': value['grant'],
        'aid': value['aid'],
    };
}

